import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import operationClaimsServices from '@src/services/operationClaims.services';

export const getAllOperationClaims = createAsyncThunk(
  'admin/getAllOperationClaims',
  async ({ body, pageNumber, pageSize }, { rejectWithValue }) => {
    try {
      const result = await operationClaimsServices.getAllClaims({ body, pageNumber, pageSize });
      return {
        ...result,
        ...body,
      };
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  },
);

export const getOperationClaimsList = createAsyncThunk(
  'admin/getOperationClaimsList',
  async ({ body }, { rejectWithValue }) => {
    try {
      return await operationClaimsServices.getOperationClaimsList({ body });
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const addOperationClaims = createAsyncThunk(
  'admin/addOperationClaims-admin',
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const response = await operationClaimsServices.addOperationClaims(data);
      dispatch(getOperationClaimsList());
      return response;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const deleteOperationClaims = createAsyncThunk(
  'admin/deleteOperationClaims',
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await operationClaimsServices.deleteOperationClaims({ id });
      return response;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const updateOperationClaims = createAsyncThunk(
  'admin/updateOperationClaims',
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const response = await operationClaimsServices.updateOperationClaims(data);
      const body = [];
      dispatch(getOperationClaimsList({ body }));
      return response;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const getPagedList = createAsyncThunk(
  'admin/getPagedList',
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await operationClaimsServices.getPagedList({ id });
      return response;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

const initialState = {
  claims: {},
  operationClaimsList: [],
  pagedList: [],
  draftedTableProperty: {
    currentPage: 1,
    page: 1,
    pageSize: 10,
    totalCount: 0,
  },
};

export const operationClaimsSlice = createSlice({
  name: 'operationClaims',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getOperationClaimsList.fulfilled, (state, action) => {
      state.operationClaimsList = action?.payload?.data?.items;
      state.draftedTableProperty = {
        currentPage: 1,
        page: 1,
        pageSize: 10,
        totalCount: action?.payload?.data?.items?.length,
      };
    });
    builder.addCase(getOperationClaimsList.rejected, (state, action) => {
      state.operationClaimsList = [];
      state.draftedTableProperty = {
        currentPage: 1,
        page: 1,
        pageSize: 10,
        totalCount: 0,
      };
    });
    builder.addCase(getPagedList.fulfilled, (state, action) => {
      state.pagedList = action?.payload?.data?.items;
    });
    builder.addCase(getAllOperationClaims.fulfilled, (state, action) => {
      state.claims = {
        ...state.claims,
        [action.payload.vouId]: {
          data: action?.payload?.data?.items || [],
          pagedProperty: action?.payload?.data?.pagedProperty,
        },
      };
    });
  },
});
